import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CodeSystemService } from 'app/mdm/terminology/codesystem/services/codesystem.service';
import { TerminologyAttribute } from 'app/mdm/terminology-lib/services/terminology-attribute';
import { AttributeDatatype } from 'app/mdm/terminology-lib/services/attribute-datatype';
import { CodeSystem } from 'app/mdm/terminology-lib/services/codesystem';
import { EditableFlexTableComponent, MessageService } from '@heda/core-hospital-ui';
import { NgForm } from '@angular/forms';
import { markAsDirty } from '@heda/core-util';

@Component({
  templateUrl: './codesystem-edit.component.html',
})
export class CodeSystemEditComponent implements OnInit {
  public isNew = false;
  public attrTypes: Array<string> = AttributeDatatype.values;
  public codeSystem: CodeSystem;
  public defaultRow: TerminologyAttribute = {};

  @ViewChild('table') public formTable: EditableFlexTableComponent<TerminologyAttribute>;
  @ViewChild('form') public form: NgForm;

  constructor(
    private codeSystemService: CodeSystemService,
    private route: ActivatedRoute,
    private location: Location,
    private messageService: MessageService
  ) {}

  public ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.codeSystemService.getCodeSystem(id).subscribe((r) => {
        this.codeSystem = r;
      });
    } else {
      this.isNew = true;
      this.codeSystem = new CodeSystem();
      this.codeSystem.behavior = 'unique';
      this.codeSystem.names = {};
      this.codeSystem.title = {};
      this.codeSystem.attributes = [];
    }
  }

  public toggleHidden(attr: string): void {
    this.codeSystem.notes = this.codeSystem.notes || {};
    this.codeSystem.notes.hidden = this.codeSystem.notes.hidden || [];
    const idx = this.codeSystem.notes.hidden.indexOf(attr);
    if (idx >= 0) {
      this.codeSystem.notes.hidden.splice(idx, 1);
    } else {
      this.codeSystem.notes.hidden.push(attr);
    }
  }

  public save(): void {
    if (!this.validate()) {
      this.messageService.error('core.msg.form.invalid');
      return;
    }
    this.codeSystemService.saveCodeSystem(this.codeSystem).subscribe(() => this.goBack());
  }

  public goBack(): void {
    this.location.back();
  }

  public validate(): boolean {
    if (!this.form.valid) {
      markAsDirty(this.form);
      return false;
    }
    if (!this.formTable.validate()) {
      return false;
    }
    return true;
  }

  public onAttrTypeChange(attr: TerminologyAttribute): void {
    if (attr.datatype === AttributeDatatype.translations) {
      attr.defaultValue = {};
    } else {
      delete attr.defaultValue;
    }
    attr.parameters = {};
  }
}
